module.exports = __webpack_public_path__ + "static/media/FranklinGothicBookRegular.e130d119.ttf";